import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/common'
import ProductionRouteSummary from '../../../components/ProductionRouteSummary'
import { ProductionRouteCreationState } from '@/features/production-routes/api/ProductionRouteModel'

export default function ProductionRouteCreationSummaryPage({
  isCreatingProductionRoute,
  createProductionRouteAndNavigateToDashboard,
  previous,
  payload
}: {
  isCreatingProductionRoute: boolean
  createProductionRouteAndNavigateToDashboard: () => void
  previous: () => void
  payload: ProductionRouteCreationState
}) {
  const { t } = useTranslation()
  const onPreviousClick = useCallback(() => {
    previous()
  }, [previous])

  return (
    <div className="space-y-4">
      <ProductionRouteSummary productionRoute={payload} />
      <div className="flex justify-between">
        <Button variant="subtle" className="w-24" onClick={onPreviousClick}>
          {t('common:previous')}
        </Button>
        <Button
          className="w-24"
          disabled={isCreatingProductionRoute}
          isLoading={isCreatingProductionRoute}
          onClick={createProductionRouteAndNavigateToDashboard}
        >
          {t('common:actions.save')}
        </Button>
      </div>
    </div>
  )
}
